module.exports = __webpack_public_path__ + "img/Cross.88831cf1.png";